export enum CustomUsersIdType {
  AllOptions = -1,
  Resident = -2,
  DefaultAssignee = -3,
  PropertyManager = -4,
}
